const ELEMENT_KEY_SEPARATOR = '%%';
const ANCESTORS_IDS_SEPARATOR = ',';
export const normalizeElementKey = el => {
  var _el$affectingAncestor;
  const ancestorIds = (_el$affectingAncestor = el.affectingAncestors) == null ? void 0 : _el$affectingAncestor.map(_ref => {
    let [id] = _ref;
    return id;
  }).join(ANCESTORS_IDS_SEPARATOR);
  return [...(el.attributeId ? [el.attributeId] : []), el.elementId, ancestorIds, el.textColor, el.bgColor].join(ELEMENT_KEY_SEPARATOR);
};
//# sourceMappingURL=normalize-element-key.js.map